import { jsx, jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { IconContext } from "react-icons";
import { ThemeStyles } from "./theme.js";
import { Button } from "./Button.js";
import { LocalizationProvider } from "./localization.js";
const iconsDefaults = {
  size: "24px",
  attr: {
    "aria-hidden": "true"
  },
  style: {
    verticalAlign: "middle"
  }
};
const zIndexBaseDefault = 1031;
const DesignSystemContext = React.createContext({
  zIndexBase: zIndexBaseDefault
});
function DesignSystemProvider({
  children,
  noTheme,
  zIndexBase = zIndexBaseDefault,
  buttonVersion = "modern",
  dateFnsLocale,
  locale = "en_US"
}) {
  const value = useMemo(() => {
    return {
      zIndexBase,
      dateFnsLocale
    };
  }, [dateFnsLocale, zIndexBase]);
  return /* @__PURE__ */ jsx(DesignSystemContext.Provider, {
    value,
    children: /* @__PURE__ */ jsx(LocalizationProvider, {
      locale,
      children: /* @__PURE__ */ jsx(IconContext.Provider, {
        value: iconsDefaults,
        children: /* @__PURE__ */ jsxs(Button.VersionProvider, {
          value: buttonVersion,
          children: [!noTheme && /* @__PURE__ */ jsx(ThemeStyles, {}), children]
        })
      })
    })
  });
}
export {
  DesignSystemContext,
  DesignSystemProvider
};
//# sourceMappingURL=DesignSystemProvider.js.map
